










import { Component } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import ContentList from "@/components/material/MaterialGroups.vue";
import Footer from "@/components/Footer.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";

@Component({
  components: {
    Header,
    ContentList,
    Footer,
  },
})
export default class UContents extends CheckUserLogin {}
